
import filters from '@/filters';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, State } from 'vuex-class';
import moment from "moment";

import PaginationMiniComponent from '@/components/paginations/PaginationMini.vue';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    PaginationMiniComponent,
  },
  filters,
})
export default class AdvertisingInactive extends Vue {

  /* VUEX */

  // ACTION
  @Action('actionSelectAdvertisementInactive', { namespace: 'advertisement' })
  private actionSelectAdvertisementInactive: any;
  @Action('actionSelectUnpagedEmployer', { namespace: 'employer' })
  private actionSelectUnpagedEmployer: any;
  @Action('actionPaginationAdvertisement', { namespace: 'advertisement' })
  private actionPaginationAdvertisement: any;
  @Action('actionResetAdvertisement', { namespace: 'advertisement' })
  private actionResetAdvertisement: any;
  @Action('actionSelectAdvertisementManage', { namespace: 'advertisement' })
  private actionSelectAdvertisementManage:any
  @Action('actionUpdateAdvertisementManage', { namespace: 'advertisement' })
  private actionUpdateAdvertisementManage:any

  // STATE
  @State('advertisement', { namespace: 'advertisement' })
  private advertisement: any;
  @State('array_advertisement', { namespace: 'advertisement' })
  private array_advertisement: any;
  @State('pagination_advertisement', { namespace: 'advertisement' })
  private pagination_advertisement: any;
  @State('array_employer', { namespace: 'employer' })
  private array_employer: any;
  @State('advertisement_manage', { namespace: 'advertisement' })
  private advertisement_manage:any

  /* INITIALIZATION */

  private advertisement_manage_tmp: any = null

  private showPopupManageAds:boolean = false
  private isEditable:boolean = false
  private slotList: any[] = [
    { value: 1, name: 'Slot 1' },
    { value: 2, name: 'Slot 2' },
    { value: 3, name: 'Slot 3' },
  ];

  @Watch("showPopupManageAds")
  private onShowModalManage(value:boolean){
    if(value) this.advertisement_manage_tmp = Object.assign({},this.advertisement_manage)
  }

  constructor() {
    super();
  }

  /* LIFECYCLE */

  private created() {
    this.actionSelectAdvertisementManage()
    this.actionResetAdvertisement();
    this.actionSelectUnpagedEmployer();
    this.clickSearch();
  }

  /* METHOD */

  private clickSearch() {
    this.actionSelectAdvertisementInactive();
  }

  private getDuration(start:string, end:string) {
    return moment.duration(moment(start).diff(moment(end))).humanize()
  }

  private clickPage(page: number, url: string) {
    if (url) {
      this.actionPaginationAdvertisement({url, page});
    } else {
      this.clickSearch();
    }
  }

  private onSubmitSlot() {
    this.isEditable = false
    this.actionUpdateAdvertisementManage()
  }

  private onCloseModalManage() {
    this.showPopupManageAds = false
    this.isEditable = false
    
    this.advertisement_manage = this.advertisement_manage_tmp
  }

  private splitName(name:string) {
    return name.replace("slot", "slot ")
  }
}
